export default __webpack_public_path__ + "static/portal/img/animation.0fb7b2d.mp4";